module.exports = __webpack_public_path__ + "img/gold_symbol_3.bfdc5029.png";